/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-restricted-syntax */
import { Result } from '@mapbox/mapbox-gl-geocoder';
import usStates from 'constants/usStates';
import useDebounce from 'hooks/useDebounce';
import React, { useEffect, useState } from 'react';
import MapService from 'services/api/map.service';
import { GeneralFunction } from 'types/common';

type ParsedResult = {
  address: string;
  state: string;
  zip: string;
  city: string;
  country: string;
  header: string;
  detail: string;
  latitude?: number;
  longtitude?: number;
};

function getUsStateCode(state: string): string | undefined {
  const found = Object.entries(usStates).find(([, name]) => name === state);

  if (found) {
    return found[0];
  }

  return undefined;
}

function parseReverseGeo(geoData: Result): ParsedResult {
  let region = '';
  let country = '';
  let city = '';
  let zip = '';

  if (geoData.context) {
    geoData.context.forEach((v) => {
      if (v.id.indexOf('postcode') >= 0) {
        zip = v.text;
      }
      if (v.id.indexOf('region') >= 0) {
        region = v.text;
      }
      if (v.id.indexOf('country') >= 0) {
        country = v.text;
      }
      if (v.id.indexOf('place') >= 0) {
        city = v.text;
      }
    });
  }

  return {
    address: geoData.place_name,
    state: region,
    city,
    zip,
    country,
    header: geoData.text,
    detail: geoData.place_name,
    longtitude: geoData.center[0],
    latitude: geoData.center[1],
  };
}

export type ISuggestionResult = {
  address1: string;
  city: string;
  state: string;
  zip: string;
  latitude?: number;
  longtitude?: number;
};

type IAddressSuggestion = {
  onChange?: GeneralFunction;
  searchText?: string;
  visible?: boolean;
};

const AddressSuggestion: React.FC<IAddressSuggestion> = ({
  onChange = (_result: ISuggestionResult) => {},
  searchText = '',
  visible = false,
}) => {
  const debounceValue = useDebounce(searchText, 700);
  const [searchResults, setSearchResults] = useState<ParsedResult[]>([]);

  const onResult = (parsedResult: ParsedResult) => {
    const stateCode = getUsStateCode(parsedResult.state);
    const { address } = parsedResult;

    const addressExtraInformationIndex =
      address.indexOf(parsedResult.city) ||
      address.indexOf(parsedResult.state) ||
      address.indexOf(parsedResult.country);
    const addressValue = parsedResult.address.substring(0, addressExtraInformationIndex - 2);
    onChange({
      address1: addressValue,
      city: parsedResult.city,
      zip: parsedResult.zip,
      state: stateCode,
      latitude: parsedResult.latitude,
      longtitude: parsedResult.longtitude,
    } as ISuggestionResult);
  };

  const searchAddress = async (text: string): Promise<void> => {
    try {
      const { data } = await MapService.getMapSuggestion(text);
      setSearchResults((data.features || []).map((feature) => parseReverseGeo(feature)));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (debounceValue.length > 1) {
      searchAddress(debounceValue);
    } else {
      // hideSuggestions();
    }
  }, [debounceValue]);

  return (
    <ul
      className='address-suggestion-ctrl'
      style={{ display: visible && searchResults.length > 0 && searchText.length > 1 ? 'block' : 'none' }}>
      {searchResults.map((searchResult, ind) => (
        <li key={ind.toString()} onClick={() => onResult(searchResult)}>
          <p className='address-suggestion-ctrl--suggestion-title'>{searchResult.header}</p>
          <p className='address-suggestion-ctrl--suggestion-address'>{searchResult.detail}</p>
        </li>
      ))}
    </ul>
  );
};

export default AddressSuggestion;
